!customElements.get('content-tabs') &&
customElements.define(
  'content-tabs',
  class ContentTabs extends HTMLElement {

    static get observedAttributes() {
      return ['active-tab-index', 'paused']
    }

    constructor() {
      super()
      this.tabCount = this.querySelectorAll('.js-tab-content')?.length ?? 0
      this.autoplay = null
      this.resumeTimeout = null
      this.initListener()
      this.initHoverListener()
      this.initMouseLeaveListener()
      this.initAutoPlay()
    }

    attributeChangedCallback(name, oldValue, newValue) {  
      if (name === 'active-tab-index') {  
        if (oldValue !== null) {
          this.querySelector(`.js-tab-trigger[data-tab-index="${oldValue}"]`)?.classList.remove('active')
          this.querySelector(`.js-tab-content[data-tab-index="${oldValue}"]`)?.classList.remove('active')
        }

        if (newValue !== null) {
          this.querySelector(`.js-tab-trigger[data-tab-index="${newValue}"]`)?.classList.add('active')
          this.querySelector(`.js-tab-content[data-tab-index="${newValue}"]`)?.classList.add('active')
        }
      }

      if (name === 'paused' && this.paused) {
        this.killAutoPlay()
        clearTimeout(this.resumeTimeout)
        this.resumeTimeout = setTimeout(() => {
          this.paused = false
          this.initAutoPlay()
        }, 3000)
      }
    }

    initListener() {
      this.addEventListener('click', this.handleClick.bind(this))
    } 

    initHoverListener() {
      this.addEventListener('mouseover', this.onHover.bind(this))
    }

    initMouseLeaveListener() {
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this))
    }

    onHover(evt) {
      if (evt.target.classList.contains('js-tab-trigger')) {
        this.paused = true
      }
    }

    onMouseLeave() {
      this.paused = true
    }

    handleClick(evt) {
      if (evt.target.classList.contains('js-tab-trigger')) {
        const clickedIndex = +evt.target.dataset.tabIndex
        if (clickedIndex !== this.activeTabIndex) {
          this.paused = true
          this.activeTabIndex = clickedIndex
        }
      }
    }

    get paused() {
      return this.hasAttribute('paused')
    }

    set paused(value) {
      if (value) {
        this.setAttribute('paused', '')
      } else {
        this.removeAttribute('paused')
      }
    }

    get activeTabIndex() {
      const value = this.getAttribute('active-tab-index')
      return value !== null ? Number(value) : 0
    }

    set activeTabIndex(index) {
      if (typeof index === 'number' && !Number.isNaN(index)) {
        this.setAttribute('active-tab-index', index)
      } else {
        this.removeAttribute('active-tab-index')
      }
    }

    initAutoPlay() {
      if (this.autoplay) return
      this.autoplay = setInterval(() => {
        if (!this.paused) {
          this.activeTabIndex =
            this.activeTabIndex < this.tabCount
              ? this.activeTabIndex + 1
              : 1
        }
      }, 2000)
    }

    killAutoPlay() {
      if (this.autoplay) {
        clearInterval(this.autoplay)
        this.autoplay = null
      }
    }
  }
)
